module.exports = __webpack_public_path__ + "img/serviceplanner-test-now-en.79c4006f.webp";